<script setup>
import { computed } from '@vue/reactivity';
import { inject } from 'vue';
import Fancybox from './Fancybox.vue';

const { item } = defineProps(['item'])
const window = inject('window')
</script>

<template>
    <Fancybox :options="{
        dragToClose: false,
        autoFocus: false,
    }" v-slot="{ close }">
        <div class="place-card">
            <div class="place-card__img">
                <img :src="item.img" alt="">
            </div>
            <div class="place-card__content">
                <div class="place-card__title">{{ item.title }}</div>
                <div class="place-card__props" v-if="item.props">
                    <div class="place-card__prop" v-for="prop in item.props">
                        {{ prop[0] }} <span>{{ prop[1] }}</span>
                    </div>
                </div>
                <div class="place-card__description" v-html="item.description"> </div>
                <div class="flex mt-8 flex-align-center">
                    <a class="place-card__more" :href="item.url" v-if="item.url">Подробнее </a>
                    <button class="btn btn--link" @click="close" :data-path-set-to="item.id" v-if="false">
                        <svg class="icon mr-2">
                            <use :xlink:href="`${window.ASSETS_DIR}img/icons.svg#path`" />
                        </svg>
                        Проложить маршрут
                    </button>
                </div>
            </div>
            <button class="place-card__close btn btn--primary btn--white-bg btn-fab" @click="close">
                <img :src="`${window.ASSETS_DIR}img/cross.svg`" alt="">
            </button>
        </div>
    </Fancybox>
</template>

<style></style>